import { UpgradeLink } from '@/components/upgrade-link';

export function UpgradePrompt() {
  return (
    <div className="flex text-muted-foreground items-baseline text-sm gap-4">
      You've reached projects limit.
      <UpgradeLink />
    </div>
  );
}
